import { Component, Input } from '@angular/core';

@Component({
    selector: 'pnx-loading',
    templateUrl: './loading.control.html'
})
export class LoadingControl {
    @Input() showLoading: boolean = false;
    @Input() position: string = '';
}


// WEBPACK FOOTER //
// ./SignClient/app/shared/controls/loading.control.ts